/* eslint-disable jsx-a11y/mouse-events-have-key-events */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useRef, useState } from 'react';
import cx from 'classnames';
import _isEmpty from 'lodash.isempty';
import _isEqual from 'lodash.isequal';
import { Icon, Link, Text } from '../../../../../../../ui-kit';
import CommentV2Header from './CommentV2Header';
import CommentV2Body from './CommentV2Body';
import RepliesV2 from '../../../../../common/RepliesV2/RepliesV2';
import {
  convertToEditorState,
  getContentState } from
'../../../../../../RichTextEditor';
import { parseJSON } from '../../../../../../../common/utils';
import AddReplyV2 from '../../../../../common/AddReplyV2';
import '../styles/_comment-v2.scss';






































const CommentV2 = ({
  user,
  commentIndex,
  comment,
  comment: { resourceId },
  commentOrderByTimeline,
  color,
  brightness,
  canResolveComment,
  isEditable,
  onSelectComment,
  isDeletable,
  handleDelete,
  onUpdateCheckbox,
  updateComment,
  deleteComment,
  pagesList,
  isShootstaUser,
  organisationName,
  isChildren = false,
  allowedVisibilityOptions,
  commentIdToEdit,
  toggleEditMode,
  createReply,
  onInputFocus,
  handleDeleteReply,
  parentComment,
  deleteReply,
  isShowAddReplyForm,
  isCommentSelected,
  hideTimestamp,
  hideVisibility,
  allowedWriteVisibilityOptions = [],
  isStoryboard,
  showShotName,
  shotsMap
}) => {
  const { commentId, content } = comment;
  const [assetIds, setAssetIds] = useState([]);
  const [visibleAddReply, setVisibleAddReply] = useState(false);

  const [commentData, setCommentData] = useState(comment || {});
  const [editorState, setEditorState] = useState(
    convertToEditorState(content || '')
  );
  const [isHovered, setIsHovered] = useState(false);
  const commentRef = useRef(null);

  useEffect(() => {
    if (!comment) return;
    setCommentData(comment);
  }, [comment]);

  useEffect(() => {
    if (isCommentSelected && commentRef.current) {
      commentRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  }, [isCommentSelected]);

  const { metadata, children = [] } = commentData;
  const { page, visibility: commentVisibilty, commentOrigin } = parseJSON(metadata) || {};

  const showReplyButton = isShowAddReplyForm && (
  commentOrigin !== 'REVIEW' ||
  allowedWriteVisibilityOptions.includes(commentVisibilty));

  const handleContentUpdate = (newEditorState) => {
    const { json } = getContentState(newEditorState);
    setEditorState(newEditorState);
    setCommentData((prev) => ({
      ...prev,
      content: json
    }));
  };

  const handleVisibilityChange = async (visibility) => {
    setCommentData((prev) => ({
      ...prev,
      metadata: JSON.stringify({ ...parseJSON(prev.metadata), visibility })
    }));
  };

  const handleSave = async () => {
    const { metadata: prevMetadata, assetIds: prevAssetIds } = comment;
    const { plainText: prevContent } = getContentState(
      convertToEditorState(content)
    );
    const { json: newContentJson, plainText: newContent } = getContentState(
      editorState
    );

    const isMetadataChanged = prevMetadata !== metadata;
    const isContentChanged = prevContent !== newContent;
    const isAssetsChanged = !_isEqual(prevAssetIds, assetIds);

    if (!newContent.trim()) return;

    const payload = {
      ...(isContentChanged ? { content: newContentJson } : {}),
      ...(isMetadataChanged ? { metadata } : {}),
      ...(isAssetsChanged ? { assetIds } : {})
    };

    if (_isEmpty(payload)) {
      toggleEditMode();
      return;
    }

    const { errors } = await updateComment(commentId, payload);
    if (errors) return;

    toggleEditMode();
  };

  const onFilesChange = (updatedAssetIds) => {
    setCommentData((prev) => ({
      ...prev,
      assetIds: updatedAssetIds
    }));
    setAssetIds(updatedAssetIds);
  };

  const handleAddReply = () => {
    toggleEditMode();
    setVisibleAddReply(true);
  };

  return (
    <div
      ref={commentRef}
      onClick={() => {
        onSelectComment({
          commentId: parentComment?.commentId,
          editMode: false
        });
      }}
      key={commentIndex}
      onMouseOver={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className={cx('comment-v2', {
        'comment-v2--comment-selected': isCommentSelected || visibleAddReply
      })}>

      <div>
        {!isChildren && page && pagesList &&
        <div className="comment-v2__page-title">
            <Text timestamp>
              Page: &nbsp;
              {pagesList[page - 1]}
            </Text>
          </div>}

        <div className="comment-v2-header">
          <CommentV2Header
            commentIndex={commentIndex}
            comment={commentData}
            commentOrderByTimeline={commentOrderByTimeline}
            brightness={brightness}
            canResolveComment={canResolveComment}
            isEditable={isEditable}
            isDeletable={isDeletable}
            toggleEditMode={toggleEditMode}
            handleDelete={handleDelete}
            onUpdateCheckbox={onUpdateCheckbox}
            updateComment={updateComment}
            deleteComment={deleteComment}
            user={user}
            hovering={isHovered}
            isChildren={isChildren}
            parentComment={parentComment}
            handleDeleteReply={handleDeleteReply}
            deleteReply={deleteReply}
            isStoryboard={isStoryboard}
            showShotName={showShotName}
            shotsMap={shotsMap} />

        </div>

        <div className="comment-v2-body">
          <CommentV2Body
            commentIndex={commentIndex}
            comment={commentData}
            editorState={editorState}
            onUpdateContent={handleContentUpdate}
            onSave={handleSave}
            onChangeVisibility={handleVisibilityChange}
            isShootstaUser={isShootstaUser}
            organisationName={organisationName}
            isChildren={isChildren}
            commentIdToEdit={commentIdToEdit}
            toggleEditMode={toggleEditMode}
            allowedVisibilityOptions={allowedVisibilityOptions}
            onFilesChange={onFilesChange}
            hideTimestamp={hideTimestamp}
            hideVisibility={hideVisibility}
            isEditable={isEditable} />

        </div>
      </div>

      {children.length > 0 &&
      <div className="comment-v2__footer">
          <RepliesV2
          commentOrderByTimeline={commentOrderByTimeline}
          color={color}
          brightness={brightness}
          canResolveComment={canResolveComment}
          isEditable={isEditable}
          isDeletable={isDeletable}
          handleDelete={handleDelete}
          onUpdateCheckbox={onUpdateCheckbox}
          updateComment={updateComment}
          deleteComment={deleteComment}
          pagesList={pagesList}
          isShootstaUser={isShootstaUser}
          organisationName={organisationName}
          toggleEditMode={toggleEditMode}
          commentIdToEdit={commentIdToEdit}
          commentData={commentData}
          handleDeleteReply={handleDeleteReply}
          deleteReply={deleteReply}
          allowedVisibilityOptions={allowedVisibilityOptions}
          hideTimestamp={hideTimestamp}
          hideVisibility={hideVisibility}
          isStoryboard={isStoryboard}
          shotsMap={shotsMap} />

        </div>}


      {showReplyButton && !isChildren &&
      <div className="comment-v2__reply">
          {visibleAddReply ?
        <AddReplyV2
          visible={visibleAddReply}
          parentComment={comment}
          createReply={createReply}
          resourceOrganisationId={resourceId}
          onInputFocus={onInputFocus}
          onClose={() => setVisibleAddReply(false)}
          hideTimestamp={hideTimestamp}
          hideVisibility={hideVisibility} /> :


        <div className="comment-v2__reply--btn">
              <Link button onClick={handleAddReply}>
                <div className="reply-btn-content">
                  <Text timestamp>Reply</Text>
                  <Icon name="reply" size={12} color="slateBlueGray" />
                </div>
              </Link>
            </div>}

        </div>}

    </div>);

};

export default CommentV2;